import React from 'react';
import { useIsMutating } from 'react-query';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { StickyFooter } from '../../../CommonComponents/OPL/StickyFooter/StickyFooter';
import { WORKFLOW_NEXT_MK } from '../../api/useWorkflowNextMutation';
import { WORKFLOW_PREVIOUS_MK } from '../../api/useWorkflowPreviousMutation';

interface Props {
  isFirstStep?: boolean;
  onPrevious?(): void;
  onNext?(): void;
  isOnPreviousLoading?: boolean;
  isOnNextLoading?: boolean;
  isOnNextDisabled?: boolean;
  isSubmit?: boolean;
  form?: string;
  nextButtonText?: React.ReactNode;
  showNextButtonIcon?: boolean;
}

export const WorkflowFooter: React.FC<Props> = ({
  isFirstStep,
  onPrevious,
  onNext,
  isOnPreviousLoading,
  isOnNextLoading,
  isOnNextDisabled,
  isSubmit,
  form,
  nextButtonText,
  showNextButtonIcon = true,
}) => {
  const isOnWorkflowPreviousLoading = useIsMutating({ mutationKey: WORKFLOW_PREVIOUS_MK }) > 0;
  const isOnWorkflowNextLoading = useIsMutating({ mutationKey: WORKFLOW_NEXT_MK }) > 0;

  return (
    <StickyFooter>
      {!isFirstStep && onPrevious && (
        <Button
          onClick={onPrevious}
          isLoading={isOnPreviousLoading || isOnWorkflowPreviousLoading}
          variant="secondary"
          leftIcon="fas fa-chevron-left"
          size="large"
          mr="auto"
        >
          Previous
        </Button>
      )}

      <Button
        type={isSubmit ? 'submit' : 'button'}
        onClick={onNext}
        isLoading={isOnNextLoading || isOnWorkflowNextLoading}
        disabled={isOnNextDisabled}
        size="large"
        rightIcon={showNextButtonIcon ? 'fas fa-chevron-right' : undefined}
        ml={isFirstStep ? 'auto' : '8'}
        form={form}
      >
        {nextButtonText || 'Next'}
      </Button>
    </StickyFooter>
  );
};
